import React from 'react'
import Reveal from 'react-reveal/Reveal'

class OnScroll extends React.Component {
  state = {
    revealed: false,
  }

  onReveal = () => {
    setTimeout(() => {
      this.setState({ revealed: true })
    }, 1000)
  }

  render() {
    return (
      <Reveal onReveal={this.onReveal} delay={1000}>
        {this.props.children(this.state.revealed)}
      </Reveal>
    )
  }
}

export default OnScroll
